import type { GrSelectOption } from '@components/forms';

/** AI response tones, shared by the account's response settings and each person's override. */
export const RESPONSE_TONE_OPTIONS: GrSelectOption<string>[] = [
  { label: 'Warm', value: 'warm' },
  { label: 'Professional', value: 'professional' },
  { label: 'Apologetic', value: 'apologetic' },
  { label: 'Concise', value: 'concise' },
  { label: 'Enthusiastic', value: 'enthusiastic' },
];
